module.exports = __webpack_public_path__ + "assets/scene-pic4.png";